import { Link } from 'react-router-dom';

const REPORTS = [
  { nome: 'Painel Executivo', rota: '/relatorios/painel-executivo', categoria: 'Executivo', descricao: 'Top despesas, concentracao de receitas, variacoes e alertas' },
  { nome: 'Dashboard Avancado', rota: '/relatorios/dashboard-avancado', categoria: 'Executivo', descricao: 'Visao grafica consolidada por periodo' },
  { nome: 'Conferencia de Saldo', rota: '/relatorios/conferencia-saldo', categoria: 'Caixa', descricao: 'Saldo anterior, entradas, saidas e saldo atual por dia/conta' },
  { nome: 'Movimentacao Patrimonial', rota: '/relatorios/movimentacao-patrimonial', categoria: 'Patrimonial', descricao: 'Razao gerencial de debitos, creditos e saldos por conta patrimonial' },
  { nome: 'DRE Visao Geral', rota: '/relatorios/dre-visao-geral', categoria: 'DRE', descricao: 'Matriz mensal/anual por contas da DRE' },
  { nome: 'DRE Comparativa', rota: '/relatorios/dre-comparativa', categoria: 'DRE', descricao: 'Comparativo M/M e A/A por conta' },
  { nome: 'DRE Sintetico', rota: '/relatorios/dre', categoria: 'DRE', descricao: 'Demonstracao consolidada por periodo' },
  { nome: 'DRE Analitico', rota: '/relatorios/dre-analitico', categoria: 'DRE', descricao: 'Detalhamento por conta e grupos' },
  { nome: 'Orcado vs Realizado', rota: '/relatorios/orcado-realizado', categoria: 'Planejamento', descricao: 'Desvios absolutos e percentuais vs orcamento' },
  { nome: 'Forecast Rolling', rota: '/relatorios/forecast-rolling', categoria: 'Planejamento', descricao: 'Projecao automatica de fim de mes' },
  { nome: 'Fluxo Caixa 90d', rota: '/relatorios/fluxo-caixa-projetado', categoria: 'Caixa', descricao: 'Projecao diaria de caixa futuro' },
  { nome: 'Aging Pagar/Receber', rota: '/relatorios/aging-pagar-receber', categoria: 'Caixa', descricao: 'Envelhecimento por faixas de vencimento' },
  { nome: 'Fechamento Mensal', rota: '/relatorios/fechamento-mensal', categoria: 'Governanca', descricao: 'Trava de periodo e log de auditoria' },
  { nome: 'Qualidade Dados', rota: '/relatorios/qualidade-dados', categoria: 'Governanca', descricao: 'Conciliacao e inconsistencias operacionais' },
  { nome: 'Margem Centro/Plano', rota: '/relatorios/margem-centro-plano', categoria: 'Rentabilidade', descricao: 'Margem por centro de custo e plano' },
];

const RelatoriosCentral = () => {
  const categorias = [...new Set(REPORTS.map((r) => r.categoria))];

  return (
    <div className="animate-fade-in">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Central de Relatorios</h1>
        <p className="text-gray-600">Catalogo com {REPORTS.length} relatorios organizados por categoria</p>
      </div>

      {categorias.map((categoria) => (
        <div key={categoria} className="mb-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-3">{categoria}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {REPORTS.filter((r) => r.categoria === categoria).map((report) => (
              <Link key={report.rota} to={report.rota} className="card hover:shadow-md transition-shadow">
                <div className="card-body">
                  <p className="text-base font-semibold text-gray-900">{report.nome}</p>
                  <p className="text-sm text-gray-600 mt-1">{report.descricao}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RelatoriosCentral;
